import React from "react";
import ProductsList from "../ProductsList/ProductsList";
import { Count, SectionContainer, SectionHeader, Title } from "./ProductSectionElements";
import { Reveal } from "../../general/Reveal";

const ProductSection = ({ title, products }) => {
  return (
    <SectionContainer>
      <Reveal>
        <SectionHeader>
          <Title>{title}</Title>
          <Count>{products.length}</Count>
        </SectionHeader>
      </Reveal>
      <ProductsList products={products} />
    </SectionContainer>
  );
};

export default ProductSection;
